// extracted by mini-css-extract-plugin
export var menuIcon = "_u2-0";
export var menuIconInline = "_u2-1";